import { combineReducers } from 'redux';
import {
    SET_HOVER_EVENT_TARGET,
    GOOGLE_MAPS_SCRIPT_LOADED,
    OPEN_CLOSE_ANIMATED_DRAWER,
    SET_FILTER_TYPE_TO_SHOW,
} from '../actions/ui';

const isAnimatedDrawerOpen = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === OPEN_CLOSE_ANIMATED_DRAWER) {
        nextState = payload.open;
    }

    return nextState;
};

const filterTypeToShow = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === OPEN_CLOSE_ANIMATED_DRAWER) {
        nextState = payload.filterType || '';
    } else if (type === SET_FILTER_TYPE_TO_SHOW) {
        nextState = payload;
    }

    return nextState;
};

const isGoogleMapLoaded = (state = false, { type }) => {
    let nextState = state;

    if (type === GOOGLE_MAPS_SCRIPT_LOADED) {
        nextState = true;
    }

    return nextState;
};

const eventHoverTarget = (state = null, { type, payload }) => {
    let nextState = state;

    if (type === SET_HOVER_EVENT_TARGET) {
        nextState = payload;
    }

    return nextState;
};

export default combineReducers({
    eventHoverTarget,
    isGoogleMapLoaded,
    isAnimatedDrawerOpen,
    filterTypeToShow,
});
